module.exports = __webpack_public_path__ + "static/media/Access_Table_Template.bb11b6bd.xlsx";